// Engage V2.1 — product-shape helpers shared by analytics and views.
// Kept out of gaUtils (per review) and out of common.js (which imports
// gaUtils — a cycle).

// Uploaded files become CARD products whose target is a wishlink CDN file
// URL; that's what distinguishes them from CARDs made from pasted links
// (e.g. Google links converted by the scrape pipeline).
// Hosts where files uploaded through Wishlink live. Uploads are moving from
// cdn-alabaster.wishlink.com to images.wishlink.com (images) and
// videos.wishlink.com (videos).
const WISHLINK_UPLOAD_HOSTS = ["images.wishlink.com", "videos.wishlink.com"];

export const isWishlinkCdnUrl = (url) => {
  try {
    const host = new URL(url).hostname.toLowerCase();
    return (
      (host.startsWith("cdn-") && host.includes(".wishlink.")) ||
      WISHLINK_UPLOAD_HOSTS.includes(host)
    );
  } catch {
    return false;
  }
};

/** Coarse product bucket: "text" | "uploaded_file" | "card_link" | "link". */
export const getProductType = (product) => {
  if (product?.customization_type === "TEXT") return "text";
  if (product?.customization_type === "CARD") {
    return isWishlinkCdnUrl(product?.custom_engage_values?.url || "")
      ? "uploaded_file"
      : "card_link";
  }
  return "link";
};
